import RadioButton from '../../../shared/RadioButton';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { locationTypesReadable } from '../helpers';
import Header from '../../../shared/Header';
import { Stack } from '../../../shared/layouts';

const LocationTypeStep = ({
  location_type,
  appointmentTypes,
  handleChangeAppointment,
  setDisabled
}) => {
  const { t } = useTranslation();

  const availableLocationTypes = Array.from(
    new Set(
      appointmentTypes
        .filter(current => current?.location_type)
        .map(item => item.location_type)
    )
  );
  const locationTypeOptions = availableLocationTypes.map(lt => ({
    value: lt,
    label: locationTypesReadable[lt]
  }));

  useEffect(() => {
    if (locationTypeOptions.length === 1) {
      handleChangeAppointment({
        target: { name: 'location_type', value: locationTypeOptions[0].value }
      });
    }
  }, []);

  useEffect(() => {
    if (location_type) setDisabled(false);
  }, [location_type]);

  return (
    <Stack space={'l'}>
      <Header title={t('Selecteer het type afspraak')} variant={'section'} />
      <RadioButton
        name={'locationType'}
        value={location_type}
        onChange={value =>
          handleChangeAppointment({
            target: { name: 'location_type', value: Number(value) }
          })
        }
        options={locationTypeOptions}
      />
    </Stack>
  );
};

export default LocationTypeStep;
